import { openBlock as r, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function l(s, e) {
  return r(), t("svg", n, [...e[0] || (e[0] = [
    o("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12.5 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
    }, null, -1),
    o("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M2.049 10a8.337 8.337 0 0 1 15.903 0A8.337 8.337 0 0 1 2.05 10"
    }, null, -1)
  ])]);
}
const i = { render: l };
export {
  i as default,
  l as render
};
